import React from 'react';
import { ModalProps } from 'antd';
import { Modal, Link } from 'ui-kit';
import { StoreImportDestination, useAnalytics } from 'analytics';
import StoreBaseForm from '../StoreBaseForm';
import { StoreBaseFormProps } from '../StoreBaseForm/StoreBaseForm';
import './StoreModal.scss';

import backgroundImg from './background.png';

export interface StoreModalProps extends StoreBaseFormProps, Omit<ModalProps, 'onCancel'> {
  isOpen: boolean;
}

export default function StoreModal({
  isOpen,
  onCancel,
  onSubmit,
  initialValues,
  mode,
  ...rest
}: StoreModalProps) {
  const capture = useAnalytics();

  const handleImportClick = (event: React.MouseEvent, destination: StoreImportDestination) => {
    capture('store_import_link_clicked', { destination, source: 'create_store_modal' });
    // Nothing unmounts the modal when the link targets the page the Host is already on. Link runs
    // onClick before its modifier-key check, so a new-tab click must not close and wipe the form.
    if (!(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      onCancel();
    }
  };

  return (
    <Modal
      maskStyle={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      className="StoreModal"
      visible={isOpen}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      {...rest}
    >
      {mode === 'new' && (
        <p className="StoreModal-import">
          Have more than one property? Import them all at once —{' '}
          <Link
            to="/overview/integrations/landing/hospitableconnect/"
            onClick={(event) => handleImportClick(event, 'airbnb')}
          >
            create or sync with Airbnb
          </Link>{' '}
          or{' '}
          <Link to="/overview/integrations/" onClick={(event) => handleImportClick(event, 'pms')}>
            create or sync with your PMS
          </Link>
          .
        </p>
      )}
      <StoreBaseForm
        mode={mode}
        onSubmit={onSubmit}
        onCancel={onCancel}
        initialValues={initialValues}
      />
    </Modal>
  );
}
